/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Search, XCircle } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { useUser } from "../../Context/UserContext";
import Select from 'react-select';
import { _api } from "../../api/Api";
import AsyncSelect from "react-select/async";
import { Toast } from "../../components/ui/Toast&Alerts";
import "../../style/css/custom.css"
import { customStyleSm } from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { activeUser, userPermissions } from "../../core/redux/action";

const Header = ({ showFilters, setShowFilters }) => {
  const route = all_routes;
  const { selectedLoginUser, setSelectedLoginUser } = useUser();
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const UserDetails = useSelector((state) => state.user);

  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [show, setShow] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const handleReset = () => {
    setForm({
      currentPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
    setShow({
      current: false,
      new: false,
      confirm: false
    });
    setError("");
    setSuccess("");
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.id]: e.target.value });
    setError("");
  };

  const toggleShow = (field) => {
    setShow((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    const { currentPassword, newPassword, confirmPassword } = form;

    // ✅ Frontend validations
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Confirm password does not match.");
      return;
    }

    if (newPassword.length < 3) {
      setError("Password must be at least 4 characters.");
      return;
    }

    // ✅ API payload (sirf 4 fields)
    const payload = {
      userId: UserDetails.userId,
      email: UserDetails.email,
      oldPassword: currentPassword,
      newPassword: newPassword,
    };
    console.log(payload)
    try {
      await _api("POST", "Users/change-password", payload, (res) => {
        if (res.isSuccess) {
          Toast.fire({
            icon: "success",
            title: "Password changed successfully",
          });

          document.getElementById("closeBtn")?.click();
          handleReset();
        } else {
          setLoading(false)
          Toast.fire({ icon: "error", title: res.message });
        }
      });
    } catch (err) {
      setLoading(false)
      console.log(err);
    }
  };

  useEffect(() => {
    if (!location.pathname.includes("/customer-profile")) {
      setSelectedOption(null);
    }
    if (location.pathname.includes("/workshop-view")) {
      document.body.classList.add("mini-sidebar")
      SetToggle(false);
    } else {
      document.body.classList.add("mini-sidebar");
      SetToggle(false);
    }
  }, [location.pathname]);

  const dealers = [{
    label: "NEXGEN OEM",
    value: 1,
  }, {
    label: "ADC AUTOS : Gulshan-e-Iqbal",
    value: 101,
  }]

  const handleDealerSelect = (label, value) => {
    localStorage.setItem("selectedDealerName", label);
    localStorage.setItem("selectedDealerId", value);
    setSelectedLoginUser({
      label: label,
      value: value,
    });
  };


  // Load dealer from cookie on mount
  useEffect(() => {
    const dealerId = localStorage.getItem("selectedDealerId");
    const dealerName = localStorage.getItem("selectedDealerName");

    if (dealerId && dealerName) {
      setSelectedLoginUser({
        label: dealerName,
        value: dealerId,
      });
    } else {
      localStorage.setItem("selectedDealerId", 101);
      localStorage.setItem("selectedDealerName", "ALPHA MOTORS : Gulshan-e-Iqbal");

      setSelectedLoginUser({
        label: "ALPHA MOTORS : Gulshan-e-Iqbal",
        value: 101,
      });
    }
  }, []);

  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  useEffect(() => {
    // Add mini-sidebar class by default on component mount
    // document.body.classList.add("mini-sidebar");
  }, []);

  const slideDownSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "block";
      }
    }
  };

  const slideUpSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "none";
      }
    }
  };

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        const target = e.target.closest(".sidebar, .header-left");

        if (target) {
          body.classList.add("expand-menu");
          slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          slideUpSubmenu();
        }

        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };
  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  const _getCustomerByMobileNo = async (inputValue, callback) => {
    if (inputValue.length < 3) {
      return callback([]);
    }
    try {
      const payload = {
        searchText: inputValue,
        dealerId: 101
      }
      await _api("POST", `Customer/GlobalSearchCustomer`, payload, (response) => {
        if (response?.isSuccess && response?.data) {
          const options = response?.data?.map((user) => ({
            label: `${user.mobile} - ${user.name}`,
            value: user.mobile,
            id: user.id,
          }));
          callback(options);
        } else {
        }
      }
      );
    } catch (error) {
      console.error("API error:", error.message);
    }
  };
  const handleSelectChange = (option) => {
    setSelectedOption(option); // set selected option temporarily
    navigate("/customer-profile", { state: { userId: option?.id } });
  };

  const handleLogout = () => {
    localStorage.removeItem("permissions")
    localStorage.removeItem("permissionsMap")
    dispatch(activeUser({}));
    dispatch(userPermissions({}));
    navigate('/sign-in')
  }

  return (
    <>
      <div className="header">
        {/* Logo */}
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          onMouseLeave={expandMenu}
        // onMouseOver={expandMenuOpen}
        >
          <Link to="/" className="logo logo-normal">
            <ImageWithBasePath src="/assets/img/logooow.png" alt="img" />
          </Link>
          <Link to="/" className="logo logo-white">
            <ImageWithBasePath src="/assets/img/DeepDMS.png" alt="img" />
          </Link>
          <Link to="/" className="logo-small">
            <ImageWithBasePath src="/assets/img/logoooIcon.png" alt="img" />
          </Link>
          <Link
            id="toggle_btn"
            to="#"
            style={{
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                  ? "none"
                  : "",
            }}
            onClick={(e) => {
              e.preventDefault(); // prevent anchor navigation
              handlesidebar();
            }}
          >
            <FeatherIcon icon="chevrons-left" className="feather-16" />
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        {/* Header Menu */}
        <ul className="nav user-menu">
          {/* Search */}
          <div className="nav-item nav-searchinputs col-md-3">
            <AsyncSelect
              className="select2"
              cacheOptions
              defaultOptions={false}
              loadOptions={_getCustomerByMobileNo}
              placeholder="Select Contact Number"
              onChange={handleSelectChange}
              value={selectedOption}
              styles={customStyleSm}
              noOptionsMessage={({ inputValue }) =>
                inputValue
                  ? "No matching numbers found"
                  : "Type to search mobile numbers"
              }
            //value={selectedOption}
            />
          </div>
          {/* /Search */}


          {/* Dealer Select - Inline Layout */}
          {/* <div
            className="col-md-4 d-flex align-items-center "
            style={{
              gap: "5px", // space between label & dropdown
            }}
          >
            <label
              htmlFor="dealer"
              className="fw-semibold text-secondary"
              style={{ whiteSpace: "nowrap", fontSize: "12px" }}
            >
              Dealer:
            </label>

            <div style={{ flex: 1 }}>
              <Select
                id="dealer"
                classNamePrefix="react-select"
                options={dealers}
                styles={customStyleSm}
                placeholder="Select Dealer"
                value={dealers.find((d) => d.value === selectedLoginUser?.value)}
                onChange={(i) => handleDealerSelect(i.label, i.value)}
              />
            </div>
          </div> */}

          {(location.pathname === route.AfterSalesDashboard ||
            location.pathname === route.dashboard) && (
              <li className="nav-item nav-item-box">
                <Link
                  to="#"
                  id="btnfilter"
                  onClick={() => setShowFilters(prev => !prev)}
                  title={showFilters ? "Hide Filters" : "Show Filters"}
                >
                  <FeatherIcon icon="filter" />
                </Link>
              </li>
            )}
          <li className="nav-item nav-item-box">
            <Link
              to="#"
              id="btnFullscreen"
              onClick={(e) => {
                e.preventDefault(); // prevent anchor navigation
                toggleFullscreen();
              }}
              className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              {/* <i data-feather="maximize" /> */}
              <FeatherIcon icon="maximize" />
            </Link>
          </li>

          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="user-letter">
                  <ImageWithBasePath
                    src="/assets/img/profiles/avator1.jpg"
                    alt="img"
                    className="img-fluid"
                  />
                </span>
                <span className="user-detail">
                  <span className="user-name">{UserDetails?.fullName}</span>
                  <span className="user-role">{UserDetails?.roles[0]?.roleName}</span>
                </span>
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <div className="profileset">
                  <span className="user-img">
                    <ImageWithBasePath
                      src="/assets/img/profiles/avator1.jpg"
                      alt="img"
                    />
                    <span className="status online" />
                  </span>
                  <div className="profilesets">
                    <h5>{UserDetails?.fullName}</h5>
                    <small>{UserDetails?.email}</small>
                  </div>
                </div>
                <hr className="m-0" />
                <Link className="dropdown-item" >
                  <i className="me-2" data-feather="settings" to="profile" />
                  My Profile
                </Link>
                <Link className="dropdown-item" data-bs-toggle="modal" data-bs-target="#change-pass" to="#">
                  <i className="me-2" data-feather="user" /> Change Password
                </Link>
                {/* {selectedLoginUser?.value != 101 && <Link className="dropdown-item" to="/register">
                  <i className="me-2" data-feather="user" /> Add Dealer
                </Link>
                } */}
                {/* to={route.generalsettings} */}

                <hr className="m-0" />
                <span role="button" className="dropdown-item logout pb-0 cursor-pointer" onClick={() => handleLogout()} to="#">
                  <ImageWithBasePath
                    src="/assets/img/icons/log-out.svg"
                    alt="img"
                    className="me-2"
                  />
                  Logout
                </span>
              </div>
            </div>
          </li>
        </ul>
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to="profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="generalsettings">
              Settings
            </Link>
            <Link className="dropdown-item" to="signin">
              Logout
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>

      <div
        className="modal fade"
        id="change-pass"
        tabIndex="-1"
        aria-labelledby="addCityLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addCityLabel">
                Change Password
              </h5>
              <button onClick={handleReset}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                {/* Current Password */}
                <div className="mb-3 input-with-icon">
                  <label htmlFor="currentPassword" className="form-label">
                    Current Password
                  </label>
                  <input
                    type={show.current ? "text" : "password"}
                    className="form-control"
                    id="currentPassword"
                    placeholder="*****"
                    value={form.currentPassword}
                    onChange={handleChange}
                  />
                  <span onClick={() => toggleShow("current")}>
                    <FeatherIcon icon={show.current ? "eye-off" : "eye"} size={18} />
                  </span>
                </div>


                {/* New Password */}
                <div className="mb-3 input-with-icon">
                  <label htmlFor="newPassword" className="form-label">
                    New Password
                  </label>
                  <input
                    type={show.new ? "text" : "password"}
                    className="form-control"
                    id="newPassword"
                    placeholder="*****"
                    value={form.newPassword}
                    onChange={handleChange}
                  />
                  <span onClick={() => toggleShow("new")}>
                    <FeatherIcon icon={show.new ? "eye-off" : "eye"} size={18} />
                  </span>

                </div>

                {/* Confirm Password */}
                <div className="mb-3 input-with-icon">
                  <label htmlFor="confirmPassword" className="form-label">
                    Confirm New Password
                  </label>
                  <input
                    type={show.confirm ? "text" : "password"}
                    className="form-control"
                    id="confirmPassword"
                    placeholder="*****"
                    value={form.confirmPassword}
                    onChange={handleChange}
                  />
                  <span onClick={() => toggleShow("confirm")}>
                    <FeatherIcon icon={show.confirm ? "eye-off" : "eye"} size={18} />
                  </span>
                </div>

                {error && <p className="text-danger">{error}</p>}
                {success && <p className="text-success">{success}</p>}
              </form>
            </div>
            <button
              type="button"
              id="closeBtn"
              className="btn btn-secondary d-none"
              data-bs-dismiss="modal"
            ></button>

            <div className="modal-footer d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin me-2" />
                    Loading...
                  </>
                ) : (
                  'Save Password'
                )}

              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={handleReset}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
